/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import _throttle from 'lodash/throttle';

import ForegroundItem from 'components/ForegroundItem';
import SwitchViewButton from 'components/SwitchViewButton';

import {
  Layer,
  BGImg,
  centerViewport as centerViewportFN,
  scroll as scrollFN,
  setBodyDimension as setBodyDimensionFN,
} from 'components/Parallax';

import { Mobile } from '../../media';
import Infopanel from '../Infopanel/Infopanel';


class Store extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null,
      scrollPosition: 50,
    };
    this.throttledScroll = _throttle(this.scroll, 20, { leading: true, trailing: true });
  }

  componentDidMount() {
    setTimeout(this.setBodyDimension, 900);
    setTimeout(this.centerViewport, 900);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledScroll);
    window.removeEventListener('resize', this.setBodyDimension);
  }


  setBodyDimension = () => {
    setBodyDimensionFN(this.bg, this.props.scrollMode, () => {
      this.setState({ scrollPosition: 50 });
    });
  }

  centerViewport = () => {
    centerViewportFN(() => {
      window.addEventListener('scroll', this.throttledScroll, false);
      window.addEventListener('resize', this.setBodyDimension, false);
    });
  }

  scroll = () => {
    scrollFN((pos) => {
      this.setState({ scrollPosition: pos });
    });
  }


  handleToggleItem = (id) => {
    this.setState((previousState) => ({
      activeItem: (id === previousState.activeItem ? null : id),
    }));
  }
  handleClosePanel = () => {
    this.setState({ activeItem: null });
  }

  render() {
    const { background, items, exitLabel } = this.props.config;
    const activeItem = items[this.state.activeItem];

    return (
      <div>
        <Layer position={this.state.scrollPosition}>
          <BGImg src={background.src} innerRef={(el) => { this.bg = el; }} />

          {Object.keys(items).map((item) => (
            <ForegroundItem
              key={item}
              id={item}
              item={items[item]}
              isActive={this.state.activeItem === item}
              toggleItem={this.handleToggleItem}
              closePanel={this.handleClosePanel}
            />
          ))}

          <SwitchViewButton
            center
            isExit
            label={exitLabel}
            onClick={this.props.onExit}
          />
        </Layer>
        {/* This is the same as in the street. i currently hesitate to extract it, because it's not clear yet, if
            post components will use parallax scrolling */}
        <Mobile>
          {activeItem &&
            <Infopanel
              id={activeItem.id}
              onClose={this.handleClosePanel}
              alignX={activeItem.infopanel.overlay.x}
              alignY={activeItem.infopanel.overlay.y}
              title={activeItem.infopanel.content.title}
              description={activeItem.infopanel.content.description}
              link={activeItem.infopanel.content.link}
            />
          }
        </Mobile>
      </div>
    );
  }
}

Store.propTypes = {
  onExit: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  scrollMode: PropTypes.string,
};

Store.defaultProps = {
  scrollMode: 'vertical',
};

export default Store;



// WEBPACK FOOTER //
// ./src/components/Store/Store.js